'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _fundsmarketing_aem_service = require('../services/fundsmarketing_aem_service');

var _fundsmarketing_aem_service2 = _interopRequireDefault(_fundsmarketing_aem_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HowToInvestCard = function (_React$Component) {
  _inherits(HowToInvestCard, _React$Component);

  function HowToInvestCard(props) {
    _classCallCheck(this, HowToInvestCard);

    return _possibleConstructorReturn(this, (HowToInvestCard.__proto__ || Object.getPrototypeOf(HowToInvestCard)).call(this, props));
  }

  _createClass(HowToInvestCard, [{
    key: 'renderLeftColumn',
    value: function renderLeftColumn() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'subheader-2 font-bold padding-bottom-25' },
          _string_utility2.default.renderFormattedLabel("How to invest subheader", "pdp-overview-howtoinvest-column-title")
        ),
        _react2.default.createElement(
          'div',
          { className: 'body2' },
          _string_utility2.default.renderFormattedLabel("How to invest body", "pdp-overview-howtoinvest-column-body")
        )
      );
    }
  }, {
    key: 'renderLinkAndImage',
    value: function renderLinkAndImage(link, imageUrl, dataTestId) {
      return _react2.default.createElement(
        'a',
        { href: '#', onClick: function onClick(event) {
            _fundsmarketing_aem_service2.default.invokeExtLinkConfirmWindow(link);
            event.preventDefault();
          } },
        _react2.default.createElement('img', { className: 'max-height-138 max-width-180', src: '' + this.props.gaiaRedirectUrl + imageUrl, 'data-testid': '' + dataTestId })
      );
    }
  }, {
    key: 'renderRightColumn',
    value: function renderRightColumn() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4' },
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover padding-all-2' },
            this.renderLinkAndImage('https://www.youinvest.co.uk/markets/investment-trusts', '/images/ajbell_how_to_invest.jpg', 'how-to-invest-ajbell-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://eqi.co.uk/', '/images/EQi_how_to_invest.jpg', 'how-to-invest-eqi-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.hl.co.uk/shares/investment-trusts', '/images/hargreaves_how_to_invest.jpg', 'how-to-invest-hargreaves-image')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4' },
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.barclays.co.uk/smart-investor/investments/funds-etfs-and-investment-trusts/', '/images/barclays_how_to_invest.jpg', 'how-to-invest-barclays-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.fidelity.co.uk/', '/images/fwi_how_to_invest.jpg', 'how-to-invest-fwi-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.ii.co.uk/investment-trusts', '/images/interactive_how_to_invest.jpg', 'how-to-invest-ajbell-image')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4' },
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.charles-stanley-direct.co.uk/app/login', '/images/csd_how_to_invest.jpg', 'how-to-invest-ii-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.halifax.co.uk/investing.html', '/images/halifax_how_to_invest.jpg', 'how-to-invest-halifax-image')
          ),
          _react2.default.createElement(
            'div',
            { className: 'min-height-138 min-width-180 display-flex align-items-center how-to-invest-hover' },
            this.renderLinkAndImage('https://www.bestinvest.co.uk/investment-types/investment-trusts', '/images/best_invest_how_to_invest.jpg', 'how-to-invest-best-invest-image')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('a', { id: 'howToInvestCard', style: { top: '-134px', display: 'block', position: 'relative', visiblity: 'hidden' } }),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: _string_utility2.default.renderFormattedLabel("How to invest", "pdp-overview-howtoinvest-header-label"),
            headerTitleId: "howToInvestCardHeaderId",
            headerTitleLabel: "",
            breakpoint: this.props.breakpoint,
            headerLabel: "",
            testId: "how-to-invest",
            disclosureText: [_string_utility2.default.getLocalizedString(this.props.intl, "How to invest disclosure", "pdp-overview-howtoinvest-disclosure")],
            placementId: "pdpCardFundManager",
            dataTest: "how-to-invest",
            shouldAlwaysShowMore: true
          },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4' },
            this.renderLeftColumn()
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xlg-8' },
            this.renderRightColumn()
          )
        )
      );
    }
  }]);

  return HowToInvestCard;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(HowToInvestCard, { withRef: true });